import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { TitleComponent } from 'app/shared/tools/title/title.component';
import { HighchartComponent } from '../highchart/highchart.component';
import { SafeHtmlPipe } from 'app/shared/tools/safe-html/safe-html';
import { InViewDirective } from 'app/directives/in-view.directive';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';
import { HighchartsService } from 'app/shared/tools/services/kla.highcharts.service';
@Component({
  selector: 'kla-venn-diagram',
  templateUrl: './venn-diagram.component.html',
  styleUrls: ['./venn-diagram.component.scss'],
  standalone: true,
  imports: [ CommonModule, TitleComponent, HighchartComponent, SafeHtmlPipe, InViewDirective, DynamicContentComponent ]
})
export class VennDiagramComponent implements OnInit {

  @Input() config: any;
  @Input() lineConfig: any;
  chart: any;
  hasLoaded: boolean = false;

  constructor(private highchartsService: HighchartsService) {
  }

  ngOnInit(): void {
  }

  onAppear(event) {
    if(event && !this.hasLoaded) {
      this.chart = new Chart({
        series: [
          {data: this.config.chart, type: 'venn', dataLabels: {
            style: {
                fontSize: '14px'
            }
        },}
        ],
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        tooltip: {
          headerFormat: ''
        },
        accessibility: {
          enabled: true,
          description: 'Venn diagram',
          point: {
            descriptionFormat: '{point.name}: {point.value}'
          },
          keyboardNavigation: {
            enabled: true
          }
        },
        chart: {
          backgroundColor: 'transparent'
        }
      });
      this.hasLoaded = true;
    }
  }

}
